import { useContext, useEffect, useState } from "react";
import { ConfigContext } from "../../../Context/ConfigContext";
import slugify from "slugify";
import { useTranslation } from "react-i18next";
import Carousel from 'react-multi-carousel';
import { toast } from 'react-toastify';
import { AddToCartNotifier } from "../../../Components/CartComponents";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { CartsContext } from "../../../Context/CartsContext";
import { axiosGet } from "../../../Apis/axiosMethods";
import { default_image } from "../../../Imgaes";

const SimilarParts = ({ ART_ID, STR_ID, part }) => {

    const { setIsCartDropdownOpen, apiURL, currency, apiB2BURL, apiHeaderJson } = useContext(ConfigContext);

    const dir = localStorage.getItem('dir');
    const { t } = useTranslation();
    const [parts, setParts] = useState([]);
    const navigate = useNavigate();

    const { AddToCart, GetCartItemQty } = useContext(CartsContext);


    const handleAddToCart = async (part, url) => {
        const partImg = part.MEDIA_SOURCE ? `${part.MEDIA_SOURCE}` : `${apiURL}/public/placeholder_category.jpeg`;

        var prev_qty = await GetCartItemQty(part?.ART_SEARCH_NUMBER);
        if (Number(1) >= Number(1) + prev_qty) {
            const item = {
                ART_ID: part?.ART_ID,
                ART_ARTICLE_NR: part?.ART_SEARCH_NUMBER,
                PRODUCT_GROUP_EN: part?.ART_PRODUCT_NAME,
                stock_price_mrp: part?.VD_PRICE,
                VD_BB_PRICE: part?.VD_BB_PRICE,
                ART_SUP_ID: part?.stock_sup_id ?? part?.SUP_ID ?? 0,
                ART_SUP_BRAND: part?.ART_SUP_BRAND,
                inventory_store_id: part?.inventory_store_id,
                stock_oe: part?.stock_oe ?? 0,
                VD_QTY: part?.VD_QTY
            }

            await AddToCart(item, 1, partImg, url);

            setIsCartDropdownOpen(true);
            window.scrollTo(0, 0);

        } else {
            toast.success(<AddToCartNotifier item_name={t('sorry_we_have_only', { value: 1 })} item_img={url} />, {})
        }
        return
    }

    const [responsive] = useState({
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 5,
            slidesToSlide: 3 // optional, default to 1.
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 3,
            slidesToSlide: 2 // optional, default to 1.
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 2,
            slidesToSlide: 1
        }
    })

    const GetParts = async (oe_number) => {
        try {
            const response = await axiosGet(`/Parts/GetMergeCrossFitParts`, {
                oe_number: oe_number,
                art_id: ART_ID,
                lang: "en",
                currency: currency,
                limit: 50,
                page: 1
            });

            if (response?.data?.success) {
                setParts(response.data.data);
            }
        } catch (error) {
            console.error("Fetch error:", error);
        }
    };



    // useEffect(() => {
    //     if (!part?.OEM_NUMBERS) return;

    //     const firstLine = part.OEM_NUMBERS.split("\n")[0];

    //     const oemNumber = firstLine.split(":")[1]?.trim();

    //     if (oemNumber) {
    //         GetParts(oemNumber);
    //     }
    // }, [part]);

    useEffect(() => {
        if (!part?.OEM_NUMBERS) return;

        const firstLine = part.OEM_NUMBERS.split("\n")[0];

        const oemNumber = firstLine
            .split(":")[1]
            ?.replace(/[\s-]+/g, "")
            .trim();

        if (oemNumber) {
            GetParts(oemNumber);
        }
    }, [part]);

    const filteredParts = parts.filter(
        item => item.ART_SEARCH_NUMBER !== part?.ART_SEARCH_NUMBER
    );

    return (
        filteredParts?.length > 0 && <div className="container">
            <div><div className="pb-5 mt-5" dir={dir} style={{ textAlign: dir === 'rtl' ? 'right' : 'left' }}>
                <h4>Similar Parts</h4>
                <Carousel
                    swipeable={false}
                    draggable={false}
                    showDots={false}
                    responsive={responsive}
                    infinite={false}
                    keyBoardControl={true}
                    transitionDuration={500}
                    containerClass="carousel-container"
                    removeArrowOnDeviceType={["tablet", "mobile"]}
                    itemClass="carousel-item-padding-40-px"
                >
                    {parts.map((item, index) => {
                        if (item.ART_SEARCH_NUMBER === part.ART_SEARCH_NUMBER) return null;

                        const slug = part?.ART_PRODUCT_NAME
                            .trim()
                            .replace(/,/g, "")
                            .replace(/\//g, "-")
                            .replace(/\s+/g, "-")
                            .replace(/-+/g, "-")
                            .replace(/^-|-$/g, "");

                        const OE_part_slug = `${slug}-${item.ART_SEARCH_NUMBER}/${item?.stock_brand_name}`;

                        const part_slug = `${slug}-${item.ART_SEARCH_NUMBER}-${item?.stock_sup_id ?? item?.SUP_ID}`;

                        const url =
                            Number(item.stock_oe) === 1
                                ? `/OE-Spare-Parts/Details/${OE_part_slug}`
                                : `/Spare-Parts/Details/${part_slug}`;

                        const partImg = item.MEDIA_SOURCE
                            ? `${item.MEDIA_SOURCE}`
                            : default_image;

                        return (
                            <div
                                key={index}
                                className="card m-3"
                                style={{
                                    height: '360px',
                                    display: 'flex',
                                    flexDirection: 'column'
                                }}
                            >
                                {/* IMAGE */}
                                <Link
                                    // onClick={() => navigate(`${url}`)}
                                    to={url}
                                    style={{
                                        height: '180px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        overflow: 'hidden',
                                        cursor: 'pointer'
                                    }}
                                >
                                    <img
                                        src={partImg || default_image}
                                        alt={item.ART_ARTICLE_NR}
                                        onError={(e) => {
                                            e.currentTarget.src =
                                                default_image;
                                        }}
                                        style={{
                                            maxHeight: '100%',
                                            maxWidth: '100%',
                                            objectFit: 'contain',
                                            marginTop: "10px"
                                        }}
                                    />

                                </Link>

                                {/* CONTENT */}
                                <div
                                    style={{
                                        padding: '10px',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        flex: 1
                                    }}
                                >
                                    <div
                                        onClick={() => navigate(`${url}`)}
                                        style={{
                                            minHeight: '60px',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        <h6 style={{ margin: '0 0 4px 0' }}>
                                            {item.ART_SUP_BRAND} {item.ART_PRODUCT_NAME}
                                        </h6>
                                        <small>
                                            {t('article_number', { value: item.ART_ARTICLE_NR })}
                                        </small>
                                    </div>

                                    {item.VD_BB_PRICE && item.VD_BB_PRICE > 0 ? (
                                        <div style={{ marginTop: 'auto' }}>
                                            <h5 style={{ margin: 0 }}>{item.display_price}</h5>
                                            {/* <small>{t('price_included_vat_excluded_delivery')}</small> */}
                                            <small>Offer price excl. 5.0% VAT, Free delivery</small>
                                        </div>
                                    ) : (
                                        <h5 style={{ marginTop: 'auto', textAlign: 'center' }}>
                                            {t('out_of_stock')}
                                        </h5>
                                    )}

                                    <button
                                        style={{ width: '100%' }}
                                        onClick={() => handleAddToCart(item, url)}
                                        className="btn btn-dark add-cart mt-1 btn-sm text-light"
                                        title={t('view_details')}>
                                        <i className="fas fa-shopping-cart mr-2"></i>
                                        {t('add_to_cart')}
                                    </button>
                                </div>
                            </div>


                        );
                    })}
                </Carousel>


            </div>
            </div>
        </div>
    )
}
export default SimilarParts;